import { render } from "./LayoutComponent.vue?vue&type=template&id=d845c0f4&scoped=true"
import script from "./LayoutComponent.vue?vue&type=script&lang=js"
export * from "./LayoutComponent.vue?vue&type=script&lang=js"

import "./LayoutComponent.vue?vue&type=style&index=0&id=d845c0f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d845c0f4"]])

export default __exports__